import axios from "@/api/axios";
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Login from '../views/Login.vue';


Vue.use(VueRouter)

const ifAuthenticated = (to, from, next) => {
    if (store.getters['auth/isAuthenticated']) {
        axios
            .get(`${process.env.VUE_APP_API_HOST}/api/admin/get-notifications`).then((response) => {
                let currentNotications = localStorage.getItem("notifications");
                let currentLength = currentNotications ? JSON.parse(currentNotications).length : 0;

                if (currentLength != response.data.length) {
                    localStorage.setItem("notifications", JSON.stringify(response.data));
                    
                    window.dispatchEvent(new CustomEvent('notifications-changed', {
                        detail: {
                            notifications: response.data
                        }
                    }));
                }
            });
        next();
        return;
    }
    next('/');
}

function lazyLoad(view) {
    return () =>
        import(`@/views/${view}.vue`)
}

const routes = [{
    path: '/',
    name: 'Login',
    component: Login,
    meta: { layout: 'login-layout' },
},
{
    path: '/about',
    name: 'About',
    component: () =>
        import( /* webpackChunkName: "about" */ '../views/About.vue')
},
{
    path: '/reset-password-email',
    name: 'ResetPasswordEmail',
    component: lazyLoad('ResetPasswordEmail'),
    meta: { layout: 'login-layout' },
},
{
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: lazyLoad('ResetPassword'),
    meta: { layout: 'login-layout' },
},

/**
 * Admin
 */
{
    path: '/admin/Home',
    name: 'DashboardAdmin',
    component: lazyLoad('admin/Home'),
    props: true,
    beforeEnter: ifAuthenticated
},
{
    path: '/admin/CorporateGroup/Create',
    name: 'CorporateGroup_New',
    component: lazyLoad('admin/CorporateGroups/Group'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/CorporateGroup/ListGroups',
    name: 'CorporateGroup_List',
    component: lazyLoad('admin/CorporateGroups/ListGroups'),
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Companies/Create',
    name: 'Companies_New',
    component: lazyLoad('admin/Companies/Company'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Companies/ListCompanies',
    name: 'Companies_List',
    component: lazyLoad('admin/Companies/ListCompanies'),
    beforeEnter: ifAuthenticated,
},
// {
//     path: '/admin/Units/Create',
//     name: 'Unit_New',
//     component: NewUnit,
//     props: true,
//     beforeEnter: ifAuthenticated,
// },
// {
//     path: '/admin/Units/ListUnits',
//     name: 'Units_List',
//     component: ListUnits,
//     props: true,
//     beforeEnter: ifAuthenticated,
// },
{
    path: '/admin/Machines/New',
    name: 'Machines_New',
    component: lazyLoad('admin/Machines/Machine'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Machines/ListMachines',
    name: 'Machines_List',
    component: lazyLoad('admin/Machines/ListMachines'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Users/New',
    name: 'Users_New',
    component: lazyLoad('admin/Users/User'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Users/ListUsers',
    name: 'Users_List',
    component: lazyLoad('admin/Users/ListUsers'),
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Documents/ActionPlan/:company_id?/:id?',
    name: 'ActionPlan',
    component: lazyLoad('admin/Documents/ActionPlanAnalyze'),
    beforeEnter: ifAuthenticated,
    props: true,
},
{
    path: '/admin/Documents/APR/:company_id?/:id?',
    name: 'APR',
    component: lazyLoad('admin/Documents/APR'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Documents/DVS/:company_id?/:id?',
    name: 'DVS',
    component: lazyLoad('admin/Documents/DVS'),
    beforeEnter: ifAuthenticated,
    props: true,
},
{
    path: '/admin/Documents/Index',
    name: 'Index_Documents',
    component: lazyLoad('admin/Documents/Index'),
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Documents/Company/:company_id',
    name: 'Company_Documents',
    component: lazyLoad('admin/Documents/CompanyDocuments'),
    beforeEnter: ifAuthenticated,
    props: true,
},
{
    path: '/admin/Documents/Diagnoses/:company_id?/:id?',
    name: 'Diagnoses',
    component: lazyLoad('admin/Documents/Diagnoses'),
    beforeEnter: ifAuthenticated,
    props: true,
},
{
    path: '/admin/Documents/Inventory/:company_id?/:id?',
    name: 'Inventory',
    component: lazyLoad('admin/Documents/Inventory'),
    beforeEnter: ifAuthenticated,
    props: true,
},
{
    path: '/admin/Documents/ListDocuments/:company_id/:doctype?',
    name: 'ListDocuments',
    component: lazyLoad('admin/Documents/ListDocuments'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Files/Folder',
    name: 'Folder',
    component: lazyLoad('admin/Files/Folder'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Reports/Access',
    name: 'Access',
    component: lazyLoad('admin/Reports/Access'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Reports/DocumentChanges',
    name: 'DocumentChanges',
    component: lazyLoad('admin/Reports/DocumentChanges'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/NrReferences/Reference',
    name: 'Reference',
    component: lazyLoad('admin/NrReferences/Reference'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/NrReferences/ListReferences',
    name: 'ListReferences',
    component: lazyLoad('admin/NrReferences/ListReferences'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Documents/ListDocuments/HazardManagementPlan',
    name: 'HazardManagementPlan',
    component: lazyLoad('admin/Documents/HazardManagementPlan'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Trainings/Create',
    name: 'Trainings_New',
    component: lazyLoad('admin/Trainings/Training'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Trainings/ListTrainings',
    name: 'Trainings_List',
    component: lazyLoad('admin/Trainings/ListTrainings'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Tickets/Create',
    name: 'Tickets_New',
    component: lazyLoad('admin/Tickets/Ticket'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Tickets/Create/:id',
    name: 'Tickets_View',
    component: lazyLoad('admin/Tickets/Ticket'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Tickets/ListTickets',
    name: 'Tickets_List',
    component: lazyLoad('admin/Tickets/ListTickets'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/ServiceOrders/ListServiceOrders',
    name: 'ServiceOrders_List',
    component: lazyLoad('admin/ServiceOrders/ListServiceOrders'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/ServiceOrders/New',
    name: 'ServiceOrder_New',
    component: lazyLoad('admin/ServiceOrders/ServiceOrder'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/RiskManagement',
    name: 'RiskManagement',
    component: lazyLoad('admin/RiskManagement/RiskManagement'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path : '/admin/RiskManagement/Details',
    name: 'RiskManagement_Details',
    component: lazyLoad('admin/RiskManagement/RiskDetails'),
    props: (route) => ({
        selected: route.query.selected,
    }),
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Clients/New',
    name: 'Clients_New',
    component: lazyLoad('admin/Clients/Client'),
    props: true,
    beforeEnter: ifAuthenticated,
},
{
    path: '/admin/Clients/ListClients',
    name: 'Clients_List',
    component: lazyLoad('admin/Clients/ListClients'),
    beforeEnter: ifAuthenticated,
},
]

const router = new VueRouter({
    routes
})

// Rotas cujo :company_id vem da URL, não mais do localStorage (compartilhado entre
// abas). A guarda abaixo resolve a empresa uma vez, num só lugar, cobrindo os três
// casos de borda: sem empresa selecionada, empresa inexistente, sem acesso a ela.
const COMPANY_SCOPED_ROUTES = ['Company_Documents', 'ListDocuments', 'ActionPlan', 'APR', 'DVS', 'Diagnoses', 'Inventory'];
const LIST_DOCUMENT_TYPES = ['Inventory', 'APR', 'ActionPlan', 'Diagnoses', 'DVS'];

router.beforeEach((to, from, next) => {
    if (!COMPANY_SCOPED_ROUTES.includes(to.name)) {
        next();
        return;
    }

    const companyId = to.params.company_id;
    if (!companyId) {
        next({ name: 'Index_Documents', query: { company_warning: 'no-company' } });
        return;
    }

    // O tipo da listagem precisa estar na própria URL. Usar localStorage aqui
    // mistura APR, DVS e outros documentos entre abas do mesmo navegador.
    if (to.name === 'ListDocuments' && !LIST_DOCUMENT_TYPES.includes(to.params.doctype)) {
        next({ name: 'Company_Documents', params: { company_id: companyId } });
        return;
    }

    axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/companies/${companyId}`)
        .then(() => next())
        .catch((error) => {
            const warning = error?.response?.status === 404 ? 'not-found' : 'access-denied';
            next({ name: 'Index_Documents', query: { company_warning: warning } });
        });
});

export default router
